import AppDispatcher from '../dispatcher/AppDispatcher';
import DealConstants from '../constants/DealConstants';
import Ajax from '../utils/Ajax';

const DealActions = {
    chooseDeal: function (data) {
        AppDispatcher.handleAction({
            actionType: DealConstants.CHOOSE_DEAL,
            data: data, // ???
        });
    },
    isracardAnonymousBookingRequest: function (data) {
        AppDispatcher.handleAction({
            actionType: DealConstants.BOOKING_REQUEST_STARTED,
        });
        Ajax.isracardAnonymousBookingRequest(data)
            .then((res) => {
                AppDispatcher.handleAction({
                    actionType: DealConstants.BOOKING_REQUEST_SUCCEEDED,
                    data: { response: res },
                });
            })
            .catch((err) => {
                AppDispatcher.handleAction({
                    actionType: DealConstants.BOOKING_REQUEST_FAILED,
                    data: { error: err },
                });
            });
    },
    resetBookingRequest: function () {
        AppDispatcher.handleAction({
            actionType: DealConstants.BOOKING_REQUEST_RESET,
        });
    },
};

export default DealActions;
